import Conversation from '@/pages/chat/components/Conversation';
import HistoryMenu from '@/pages/history/historyMenu';
import { setActiveUrl } from '@/redux/reducer';
import { RootState } from '@/typings';
import { ElDialog, ElIcon, ElLink } from '@qsxy/element-plus-react';
import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';

const Menu = () => {
	const activeUrl = useSelector((state: RootState) => state.activeUrl);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [visible, setVisible] = useState(false);

	const onMenuClick = useCallback(
		(e: React.MouseEvent<HTMLLIElement>, path: string) => {
			e.stopPropagation();
			if (activeUrl !== path) {
				dispatch(setActiveUrl(path));
			}
		},
		[activeUrl, dispatch],
	);

	const onClickKnowledge = useCallback(
		(e: React.MouseEvent<HTMLLIElement>, path: string) => {
			e.stopPropagation();
			// if (loginUser.isVisitor) {
			// 	ElMessageBox.confirm('您尚未登录，暂不能使用此功能，现在去登录？', '温馨提示', {
			// 		confirmButtonText: '去登录',
			// 		cancelButtonText: '再体验一会儿',
			// 	}).then(() => {
			// 		navigate('/login');
			// 	});
			// } else {
			// }
			if (activeUrl !== path) {
				dispatch(setActiveUrl(path));
				navigate('/knowledge');
			}
		},
		[activeUrl, dispatch, navigate],
	);

	return (
		<>
			<li className={classNames({ active: activeUrl === 'chat' })} onClick={e => onMenuClick(e, 'chat')}>
				<NavLink to="chat" className="ttn-menu-item">
					<ElIcon prefix="fas" name="home"></ElIcon>
					<span>首页</span>
				</NavLink>
			</li>
			<li onClick={() => setVisible(true)}>
				<ElLink className="ttn-menu-item">
					<ElIcon prefix="fas" name="comment-medical" size="large"></ElIcon>
					<span>创建会话</span>
				</ElLink>
			</li>
			<li className={classNames({ active: activeUrl === 'knowledge' })} onClick={e => onClickKnowledge(e, 'knowledge')}>
				<ElLink className="ttn-menu-item">
					<ElIcon prefix="fas" name="cloud-word"></ElIcon>
					<span>知识库</span>
				</ElLink>
			</li>
			<HistoryMenu />

			<ElDialog title="创建会话" visible={visible} close={() => setVisible(false)} width={900} closeOnClickModal={true}>
				<Conversation showSample={false} onSend={() => setVisible(false)} />
			</ElDialog>
		</>
	);
};

export default Menu;
